<div class="content">
  <h1>Frequently Asked Questions</h1>
  <mat-accordion multi>
    @for (faq of faqs; track $index) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <span>{{faq.category}}</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ul>
        @for (q of faq.questions; track $index) {
        <li>
          <strong>{{q.q}}</strong>
          <div [innerHTML]="q.a"></div>
        </li>
        }
      </ul>
    </mat-expansion-panel>
    }
  </mat-accordion>
</div>
